import { checkIsPortableDevice } from '../utils/checkIsPortableDevice';

export const IS_PORTABLE_DEVICE = checkIsPortableDevice();
